var WISHLIST_DATA = {};

function initWishlist(pageType) {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    if (ENV.customerEmail) {
        fetch("/apps/f21/api/wishlist/", 
        {
            method: "POST",
            headers: myHeaders,
            body: '{"email": "' + ENV.customerEmail + '"}',
            redirect: "follow"
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
        .then((result) => { 
            WISHLIST_DATA = result;
            //console.log(result);
            if (result && result.code == '00') {
                if (pageType == 'collection') {
                    const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon');
                    wishlistItems.forEach(item => {
                        if (result.LineItems && result.LineItems.length > 0 && result.LineItems.find(li => li.ProductId === item.getAttribute('data-product-handle'))) {
                            item.classList.add('selected');
                        }

                        // show wishlist icon
                        item.style.display = 'block';

                        // prevent adding multiple event listeners
                        item.removeEventListener('click', handleWishlistButtonClick);
                        item.addEventListener('click', function() {handleWishlistButtonClick(item, pageType);});
                    });
                } else { 
                    patchHiddenInput('input[name="selectedVariantId"]');
                    const selectedVariantId = getSelectedVariantIdValue();
                    const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon.main-product');
                    wishlistItems.forEach(item => {
                        if (result.LineItems && result.LineItems.length > 0 && result.LineItems.find(li => li.SelectedCartVariantId === 'gid://shopify/ProductVariant/' + selectedVariantId)) {
                            item.classList.add('selected');
                        }

                        // Listen for variant changes
                        const mainAddToCartForm = document.querySelector('form[id*="product-form-main"]');
                        if (mainAddToCartForm) {
                            const idInput = mainAddToCartForm.querySelector('input[name="id"]');
                            if (idInput) {
                                const hiddenVariantId = document.querySelector('input[name="selectedVariantId"]');
                                hiddenVariantId.value = idInput.value;
                                // prevent adding multiple event listeners
                                hiddenVariantId.removeEventListener('hidden:valuechange', function() {
                                    updatePDPWishlistIconState(getSelectedVariantIdValue());
                                });
                                hiddenVariantId.addEventListener('hidden:valuechange', function() {
                                    updatePDPWishlistIconState(getSelectedVariantIdValue());
                                });
                            }
                        }

                        // Also listen for clicks on the wishlist icon
                        item.removeEventListener('click', function() { handleWishlistButtonClick(item, pageType); });
                        item.addEventListener('click', function() { handleWishlistButtonClick(item, pageType); });
                    });
                }
                
            }
        });
    }
}

function addToCartFromWishlist(item, pageType) {
    // add to cart
    const productId = item.getAttribute('data-product-id');
    const handle = item.getAttribute('data-product-handle');
    const variantId = pageType == 'product' ? getSelectedVariantIdValue() : item.getAttribute('data-first-available-variant-id');

    fetch('/products/' + handle + '.js')
    .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
    .then(product => {
        const productTags = product.tags;
        const properties = {};
        if (productTags.includes('final_sale')) {
            properties['Final Sale'] = 'No Return';
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {  'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: properties
            })
        })
        .then(response => { response.json() })
        .then(data => {
            // remove from wishlist
            removeFromWishlist(item, pageType);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
}

function addToWishlist(item, pageType) {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    const productId = item.getAttribute('data-product-id');
    const variantId = pageType == 'product' ? getSelectedVariantIdValue() : item.getAttribute('data-first-available-variant-id');
    fetch("/apps/f21/api/wishlist/add", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + ENV.customerEmail + '", "productId": "gid://shopify/Product/' + productId + '", "productVariantId": "gid://shopify/ProductVariant/' + variantId + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        //console.log(result);
        WISHLIST_DATA = result;

        if (pageType == 'wishlist') {
            location.reload();
        } else {
            item.classList.add('selected');
        }
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function removeFromWishlist(item, pageType) {
    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    const productId = item.getAttribute('data-product-id');
    const variantId = pageType == 'product' ? getSelectedVariantIdValue() : item.getAttribute('data-first-available-variant-id');
    fetch("/apps/f21/api/wishlist/remove", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + ENV.customerEmail + '", "productId": "gid://shopify/Product/' + productId + '", "productVariantId": "gid://shopify/ProductVariant/' + variantId + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        //console.log(result);
        WISHLIST_DATA = result;

        if (pageType == 'wishlist') {
            location.reload();
        } else {
            item.classList.remove('selected');
        }
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function renderWishlistHTML() {
    const wishlistContainer = document.getElementById('WishlistContainer');
    const wishlistSection = document.getElementById('WishlistSection');
    const wishlistEmptyMessage = document.getElementById('WishlistEmptyMessage');

    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    if (ENV.customerEmail) {
        fetch("/apps/f21/api/wishlist/", 
        {
            method: "POST",
            headers: myHeaders,
            body: '{"email": "' + ENV.customerEmail + '"}',
            redirect: "follow"
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
        .then((result) => { 
            //console.log(result);

            if (result && result.code == '00' && result.LineItems && result.LineItems.length > 0) {
                const productListHTML = result.LineItems.map(product => {
                    const allSizes = product.Variants.flatMap(item => {
                        return Array.isArray(item.Sizes) ? item.Sizes : [];
                    });
                    const formattedPrice = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(product.ListPrice);
                    const selectedSKU = allSizes.find(variant => variant.VariantId === product.SelectedCartVariantId);
                    
                    const shopifyProductIdParts = product.ShopifyId.split('/');
                    const shopifyProductId = shopifyProductIdParts[shopifyProductIdParts.length - 1];
                    const parts = product.SelectedCartVariantId.split('/');
                    const SKU = parts[parts.length - 1];
                    return `
                    <tr>
                        <td>
                            <line-item class="line-item">
                                <img src="${product.SmallSizeProductImage}?v=1751196064&amp;width=1000" alt="0043991708#Color_BLUE" width="1000" height="1500" loading="lazy" sizes="(max-width: 699px) 70px, 120px" class="line-item__media">
                                <div class="line-item-info">
                                    <div class="v-stack justify-items-start gap-2">
                                        <div class="v-stack justify-items-start gap-1">
                                            <a href="/products/${product.ProductId}" class="h6">${product.DisplayName}</a>
                                            <price-list class="price-list ">
                                                <sale-price class="h6 text-subdued"><span class="sr-only">Sale price</span>${formattedPrice}</sale-price>
                                            </price-list>
                                        </div>
                                        <div class="v-stack justify-items-start gap-1">
                                            <p class="smallcaps text-subdued">${selectedSKU.Title}</p>
                                        </div>
                                        <line-item-quantity class="h-stack gap-4 sm:hidden">
                                        <a href="javascript:void(0)" onclick="javascript:removeFromWishlist(this, 'wishlist');" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" class="link text-xs" aria-label="Remove">
                                            Remove
                                        </a>
                                        <a href="javascript:void(0)" onclick="javascript:addToCartFromWishlist(this, 'wishlist');" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" class="link text-xs" aria-label="Move To Cart">
                                            Move To Cart
                                        </a>
                                        </line-item-quantity>
                                    </div>
                                </div>
                            </line-item>
                        </td>
                        <td class="text-center">
                            <div class="v-stack gap-2">
                                <line-item-quantity class="v-stack justify-items-center gap-2">
                                <a href="javascript:void(0)" onclick="javascript:removeFromWishlist(this, 'wishlist');" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" class="link text-xs" aria-label="Remove">
                                    Remove
                                </a>
                                <a href="javascript:void(0)" onclick="javascript:addToCartFromWishlist(this, 'wishlist');" data-product-id="${shopifyProductId}" data-product-handle="${product.ProductId}" data-first-available-variant-id="${SKU}" class="link text-xs" aria-label="Move To Cart">
                                    Move To Cart
                                </a>
                                </line-item-quantity>
                            </div>
                        </td>
                        <td class="text-end">
                            ${formattedPrice}
                        </td>
                    </tr>
                    `;
                    }).join('');
                
                //console.log(productListHTML);
                wishlistSection.innerHTML = productListHTML;
                wishlistContainer.classList.remove('hidden');
            } else {
                wishlistEmptyMessage.classList.remove('hidden');
            }
        });
    }

    /*fetch("https://brandx-ec-proxyapi-dev.azurewebsites.net" + "/api/1/shopify/customer/saveforlater", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + email + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        console.log(result);
    });
    */
    
}

function handleWishlistButtonClick(item, pageType) {
    if (item.classList.contains('selected')) {
        // Remove from wishlist
        removeFromWishlist(item, pageType);
    } else {
        // Add to wishlist
        addToWishlist(item, pageType);
    }
}

function updatePDPWishlistIconState(selectedVariantId) {
    const wishlistItems = document.querySelectorAll('.wishlist.wishlist-icon.main-product');
    wishlistItems.forEach(item => {
        item.classList.remove('not-allowed');
        if (selectedVariantId == 'undefined' || selectedVariantId == null) {
            item.classList.add('not-allowed');
            return;
        }

        if (WISHLIST_DATA.LineItems && WISHLIST_DATA.LineItems.find(li => li.SelectedCartVariantId === 'gid://shopify/ProductVariant/' + selectedVariantId)) {
            item.classList.add('selected');
        } else {
            item.classList.remove('selected');
        }

        item.removeEventListener('click', function() {handleWishlistButtonClick(item, 'product');});
        item.addEventListener('click', function() {handleWishlistButtonClick(item, 'product');});
    });
}

function getSelectedVariantIdValue() {
    const mainAddToCartForm = document.querySelector('form[id*="product-form-main"]');

    if (!mainAddToCartForm) {
        console.error("error: can't find form with id containing 'product-form-main'");
        return null;
    }

    const idInput = mainAddToCartForm.querySelector('input[name="id"]');

    if (idInput && idInput.value) {
        const selectedVariantId = idInput.value;
        
        return selectedVariantId;
    } else {
        console.error("error: can't find input with name 'id' or it has no value");
        return null;
    }
}

function patchHiddenInput(selector) {
    const targetInput = document.querySelector(selector);

    if (!targetInput) {
        console.error(`Error: Input element not found for selector: ${selector}`);
        return;
    }

    let internalValue = targetInput.value;

    Object.defineProperty(targetInput, 'value', {
        get() {
            return internalValue;
        },
        set(newValue) {
            if (internalValue !== newValue) {
                const oldValue = internalValue;
                internalValue = newValue;
                
                const changeEvent = new CustomEvent('hidden:valuechange', {
                    detail: { oldValue, newValue }
                });
                targetInput.dispatchEvent(changeEvent);
            }
        },
        configurable: true
    });
}